"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
import dynamic from "next/dynamic";
import { useHomeSlug } from "@/queries/home";
const MobileMenu = dynamic(() => import("@/components/layout/mobilemenu/MobileMenu"));
import HomeHero from "./HomeHero";
import HomeSectionsList from "./HomeSectionsList";
import { useHeroSlides } from "./useHeroSlides";
import { useHomeSections } from "./useHomeSections";
import { useKidsTheme } from "./useKidsTheme";
interface Props {
  slug: string;
}
export default function HomeSlug(t0) {
  const $ = _c(23);
  const {
    slug
  } = t0;
  const {
    data: homeResponse,
    isLoading,
    isError
  } = useHomeSlug(slug);
  const homeData = homeResponse?.data;
  console.log("slug", slug);
  const heroSlides = useHeroSlides(homeData?.hero?.items, slug === "business");
  const {
    visibleSections,
    hasMore,
    sentinelRef
  } = useHomeSections(homeData?.sections);
  useKidsTheme(slug);
  let t1;
  if ($[0] !== homeData) {
    t1 = () => {
      if (homeData?.subpages) {
        localStorage.setItem("subpages", JSON.stringify(homeData.subpages));
      }
    };
    $[0] = homeData;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = homeData?.subpages;
  let t3;
  if ($[2] !== t2) {
    t3 = [t2];
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  useEffect(t1, t3);
  if (isError) {
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <div className="rounded-xl bg-white/5 p-4 text-sm text-red-300 mx-4 mt-4">خطا در دریافت اطلاعات صفحه اصلی</div>;
      $[4] = t4;
    } else {
      t4 = $[4];
    }
    return t4;
  }
  const t4 = `${slug === "kids2" ? "mx-auto container max-w-3xl px-4 sm:px-6 md:px-20 relative w-full mt-18 min-h-auto md:min-h-auto lg:mb-16 mb-0 md:mb-0 " : "relative min-h-auto md:min-h-auto lg:min-h-auto xl:min-h-screen lg:pt-0"}`;
  const t5 = `${slug === "kids2" ? "fullscreengrab" : "fullscreen"}`;
  let t6;
  if ($[5] !== heroSlides || $[6] !== isLoading || $[7] !== t5) {
    t6 = <HomeHero variant={t5} slides={heroSlides} isLoading={isLoading} />;
    $[5] = heroSlides;
    $[6] = isLoading;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t4 || $[10] !== t6) {
    t7 = <div className={t4}>{t6}</div>;
    $[9] = t4;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== hasMore || $[13] !== isLoading || $[14] !== sentinelRef || $[15] !== visibleSections) {
    t8 = <div className="mx-auto container max-w-3xl px-4 sm:px-6 md:px-10 mt-8 relative z-40"><HomeSectionsList isLoading={isLoading} visibleSections={visibleSections} hasMore={hasMore} sentinelRef={sentinelRef} /></div>;
    $[12] = hasMore;
    $[13] = isLoading;
    $[14] = sentinelRef;
    $[15] = visibleSections;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t7 || $[18] !== t8) {
    t9 = <div className="flex flex-col pb-8">{t7}{t8}</div>;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <MobileMenu />;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t9) {
    t11 = <>{t9}{t10}</>;
    $[21] = t9;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  return t11;
}